import {
    get,
    post
} from "./request.js";
export default {
    // 基础信息
    jconfig(data) {
        return post('/index/jconfig', data)
    },
    // 轮播图
    swiper(data) {
        return post('/index/index', data)
    },
    // 栏目
    cate(data) {
        return post('/index/cate', data)
    },
    // 首页显示“党的建设”
    partybuilding(data) {
        return post('/index/partybuilding', data)
    },
    // 首页显示“集团要闻”
    homeNews(data) {
        return post('/index/news', data)
    },
    // 首页显示“基层动态”
    unitnews(data) {
        return post('/index/unitnews', data)
    },
    // 党的建设详情
    partydt(data) {
        return post('/index/partydt', data)
    },
    // 业务领域
    business(data) {
        return post('/index/business', data)
    },
    // 业务领域详情
    businessdt(data) {
        return post('/index/businessdt', data)
    },
    // 党的建设
    partys(data) {
        return post('/index/partys', data)
    },
    // 关于集团
    about(data) {
        return post('/index/about', data)
    },
    // 报名须知
    signup(data) {
        return post('/index/signup', data)
    },
    // 招聘列表
    hire(data) {
        return post('/index/hire', data)
    },
    // 招聘详情
    hiredt(data) {
        return post('/index/hiredt', data)
    },
    // 联系我们
    abouts(data) {
        return post('/index/abouts', data)
    },
    // 新闻页列表展示
    article(data) {
        return post('/index/article', data)
    },
    // 新闻页列表内页
    articlelist(data) {
        return post('/index/articlelist', data)
    },
    // 新闻详情
    articledt(data) {
        return post('/index/articledt', data)
    },
    // 招标采购\通知公告
    message(data) {
        return post('/index/message', data)
    },
    // 招标采购详情
    messagedt(data) {
        return post('/index/messagedt', data)
    },
    // OA
    insert(data) {
        return post('/article/insert', data)
    },
    // 搜索
    searchnew(data) {
        return post('/index/searchnew', data)
    },
    // 头部轮播图2
    tyoebanner(data) {
        return post('/index/typebanner', data)
    },
    // oa链接
    jconfig(data) {
        return post('/index/jconfig', data)
    },
    // oa链接
    djcate(data) {
        return post('/index/djcate', data)
    },
}
